export { default } from './TrophyStarAlternate'
